import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-institution-group',
  templateUrl: './admin-institution-group.component.html',
  styleUrls: ['./admin-institution-group.component.css']
})
export class AdminInstitutionGroupComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  institutiongroups: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddinstitutiongroup = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;
  booleanlist: SelectItem[] = [{ label: 'Visa alla', value: null }, { label: 'Ja', value: true }, { label: 'Nej', value: false }];

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Namn' },
      { field: 'description', header: 'Beskrivning' },
      { field: 'primary', header: 'Primary' },
      { field: 'managed', header: 'Managed' },
      { field: 'terminal', header: 'Terminal' }
    ];
    this.getInstitutionGroups();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getInstitutionGroups() {
    this.adminService.GetInstitutionGroups().subscribe(data => {
      if (data) {
        this.institutiongroups = data;
      }
    });
  }

  saveInstitutionGroup(evt) {
    this.adminService.UpdateInstitutionGroup(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionsgrupp uppdaterad.' });
      this.getInstitutionGroups();
    });
  }

  saveAddInstitutionGroup(evt) {
    this.adminService.AddInstitutionGroup(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionsgrupp tillagd.' });
        this.getInstitutionGroups();
      }
    });
    this.displayaddinstitutiongroup = false;
  }

  cancelEdit() {
    this.display = false;
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
    this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald institutionsgrupp?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.deleteInstitutionGroup(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteInstitutionGroup(rowdata) {
    this.adminService.RemoveInstitutionGroup(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Institutionsgrupp raderad.' });
        this.getInstitutionGroups();
      }
    });
  }

  cancelAdd() {
    this.displayaddinstitutiongroup = false;
  }
  addCommittee() {
    this.displayaddinstitutiongroup = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    let firstrow = '';
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });

    const excelrecords: any[] = [];
    this.institutiongroups.forEach(r => {
      const row = {
        name: r.name,
        description: r.description,
        primary: r.primary,
        managed: r.managed,
        terminal: r.terminal
      }
      excelrecords.push(row);
    });
    const filnamn = 'OF_institutiongroups';
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }
}
